export const loanDrilldownSidebarTypes = {
  FILE_PREVIEW: "filePreview",
  FILE_UPLOAD: "fileUpload",
  SIZER_UPLOAD: "sizerUpload",
  FORMSPY: "formSpy",
  COMMENTS: "comments",
  ADD_BORROWER: "addBorrower",
  ADD_PROPERTY: "addProperty",
  ADD_EXCEPTION: "addLoanException",
  UW_NOTES: "uwNotes",
  UW_CHECKLIST: "uwChecklist",
  LOAN_TOTALS: "loanTotals",
};
